import { Pipe, type PipeTransform } from '@angular/core';
import { BuildingPrimaryPropertyType } from '@quipex/shared/contracts';
import type { QPX_LUCIDE_ICONS } from '../directives/icon/lucide-icons';

const icons = {
    [BuildingPrimaryPropertyType.HouseTownhouseVilla]: 'lucideHouse',
    [BuildingPrimaryPropertyType.DuplexSemiDetached]: 'qpxDuplex',
    [BuildingPrimaryPropertyType.BoardingHouseGuestHouse]: 'qpxBoardingHouse',
    [BuildingPrimaryPropertyType.ApartmentUnitBlock]: 'qpxBuildingComplex',
    [BuildingPrimaryPropertyType.HotelMotelHostel]: 'lucideHotel',
    [BuildingPrimaryPropertyType.CaretakersResidenceWithinNonResidential]:
        'qpxCaretakerResidence',
    [BuildingPrimaryPropertyType.AgedCareFacility]: 'lucideHouseHeart',
    [BuildingPrimaryPropertyType.RetirementVillage]: 'qpxRetirementVillage',
    [BuildingPrimaryPropertyType.OfficeBuilding]: 'lucideBuilding',
    [BuildingPrimaryPropertyType.GpMedicalPractice]: 'lucideCross',
    [BuildingPrimaryPropertyType.RetailShop]: 'lucideStore',
    [BuildingPrimaryPropertyType.RestaurantCafeBar]: 'lucideUtensils',
    [BuildingPrimaryPropertyType.Showroom]: 'qpxShowroom',
    [BuildingPrimaryPropertyType.ShoppingCentre]: 'qpxShoppingCentre',
    [BuildingPrimaryPropertyType.CarPark]: 'lucideSquareParking',
    [BuildingPrimaryPropertyType.WarehouseStorage]: 'lucideWarehouse',
    [BuildingPrimaryPropertyType.FactoryManufacturing]: 'lucideFactory',
    [BuildingPrimaryPropertyType.LaboratoryWorkshop]: 'lucideFlaskConical',
    [BuildingPrimaryPropertyType.HospitalHealthcareFacility]: 'lucideHospital',
    [BuildingPrimaryPropertyType.DaySurgeryMedicalCentre]: 'qpxDaySurgery',
    [BuildingPrimaryPropertyType.SchoolEducation]: 'qpxSchool',
    [BuildingPrimaryPropertyType.ChildcareCentre]: 'lucideBaby',
    [BuildingPrimaryPropertyType.UniversityTafe]: 'lucideUniversity',
    [BuildingPrimaryPropertyType.TheatreAssemblyHall]: 'lucideTheater',
    [BuildingPrimaryPropertyType.ChurchPlaceOfWorship]: 'lucideChurch',
    [BuildingPrimaryPropertyType.CommunityHall]: 'qpxCommunityHall',
    [BuildingPrimaryPropertyType.SportsFacilityStadium]: 'qpxStadium',
    [BuildingPrimaryPropertyType.TransportTerminal]: 'lucideTrainFront',
    [BuildingPrimaryPropertyType.LibraryMuseumGallery]: 'lucideLandmark',
    [BuildingPrimaryPropertyType.ShedGarageCarport]: 'qpxShedGarage',
    [BuildingPrimaryPropertyType.SwimmingPoolEnclosure]: 'lucideWavesLadder',
    [BuildingPrimaryPropertyType.FenceRetainingWall]: 'lucideBrickWall',
    [BuildingPrimaryPropertyType.PrivateBushfireShelter]: 'qpxBushfireShelter',
} as const satisfies Record<
    BuildingPrimaryPropertyType,
    keyof typeof QPX_LUCIDE_ICONS
>;

@Pipe({ name: 'qpxBuildingPropertyTypeIcon' })
export class BuildingPropertyTypeIconPipe implements PipeTransform {
    public transform(
        value: BuildingPrimaryPropertyType | null | undefined
    ): keyof typeof QPX_LUCIDE_ICONS {
        return getBuildingPropertyTypeIcon(value);
    }
}

export function getBuildingPropertyTypeIcon(
    value: BuildingPrimaryPropertyType | null | undefined
): keyof typeof QPX_LUCIDE_ICONS {
    return value == null
        ? 'lucideBuilding2'
        : (icons[value] ?? 'lucideBuilding2');
}
